import React, { FC } from "react";
import { addMonths, format, subMonths } from "date-fns";
import { nb } from "date-fns/locale";
import { capitalize } from "../../Helpers";

interface MonthPickType {
  currentMonth: Date;
  handleButtonClick: (newMonth: Date) => void;
  displayBackButton: boolean;
}

export const MonthPicker: FC<MonthPickType> = ({
  currentMonth,
  handleButtonClick,
  displayBackButton,
}) => {
  return (
    <div className="d-flex justify-content-center mb-3">
      {displayBackButton && (
        <button
          className="prev-next-simple prev"
          onClick={() => handleButtonClick(subMonths(currentMonth, 1))}
          type="button"
        >
          <span className="visually-hidden">Forrige måned</span>
        </button>
      )}
      <span className="fw-bold align-self-center">
        {capitalize(format(currentMonth, "MMMM yyyy", { locale: nb }))}
      </span>
      <button
        className="prev-next-simple next"
        onClick={() => handleButtonClick(addMonths(currentMonth, 1))}
        type="button"
      >
        <span className="visually-hidden">Neste m&aring;ned</span>
      </button>
    </div>
  );
};
